const errors = {
    EN: {
        UNAUTHORIZED: 'Email or password is incorrect.',
        VALIDATION_ERROR: 'VALIDATION_ERROR',
        USER_ALREADY_ACTIVE: 'USER_ALREADY_ACTIVE',
        USER_NOT_FOUND_IN_THE_DATABASE: 'User not found in the database.',
        VALID_TOKEN_NOT_FOUND: 'Valid token not found.',
        OLD_PASSWORD_MISMATCH: 'OLD_PASSWORD_MISMATCH',
        USER_ACCOUNT_NOT_ACTIVE: 'USER_ACCOUNT_NOT_ACTIVE',
        POINT_OF_INTEREST_NOT_FOUND_IN_THE_DATABASE: 'POINT_OF_INTEREST_NOT_FOUND_IN_THE_DATABASE',
        INTERNAL_ERROR: 'INTERNAL_ERROR',
        LOGIN_EMAIL_ALREADY_EXISTS: 'Login email already exists',
        activateUserComplete: {
            VALID_TOKEN_NOT_FOUND: 'Valid activation token not found.'
        },
        somethingWentWrong: 'Something went wrong... Try again',
        VIN_ALREADY_IN_DATABASE: 'Vin already exists',
        LICENSE_PLATE_IS_ALREADY_IN_DATABASE: 'license plate already exists',
        OUTDATED_TECHNICIAN_INSURANCE: "Technician doesn't  have a current policy",
        number: 'Must be a number',
        greaterThanZero: 'Value has to be greater than zero',
        specialCharacter: 'Password has to have one special character',
        minPasswordLength: 'Passwords length has to be greater than 8',
        oneGreatLetter: 'Password has to have one great letter',
        oneSmallLetter: 'Password has to have one small letter',
        oneNumber: 'Password has to have one number character',
        futureDate: 'Date needs to be from future',
        required: 'Required',
        incorrectEmail: 'Incorrect e-mail address',
        incorrectPostalCode: 'Incorrect postal code',
        incorrectPhoneNo: 'Incorrect phone number',
        incorrectLicensePlate: 'Incorrect license plate',
        incorrectDate: 'Incorrect date',
        CAR_FLEET_NOT_REMOVABLE: 'Car fleet: {{fleetId}} is not removable'
    },
    PL: {
        UNAUTHORIZED: 'Podany adres email lub hasło są niepoprawne.',
        VALIDATION_ERROR: 'Błąd walidacji wysłanych parametrów',
        USER_ALREADY_ACTIVE: 'USER_ALREADY_ACTIVE',
        USER_NOT_FOUND_IN_THE_DATABASE: 'Użytkownik nie został odnaleziony w bazie danych.',
        VALID_TOKEN_NOT_FOUND: 'Podany adres URL resetu hasła wygasł. Prosimy ponownie zrestartować hasło.',
        OLD_PASSWORD_MISMATCH: 'OLD_PASSWORD_MISMATCH',
        USER_ACCOUNT_NOT_ACTIVE: 'USER_ACCOUNT_NOT_ACTIVE',
        POINT_OF_INTEREST_NOT_FOUND_IN_THE_DATABASE: 'POINT_OF_INTEREST_NOT_FOUND_IN_THE_DATABASE',
        INTERNAL_ERROR: 'INTERNAL_ERROR',
        LOGIN_EMAIL_ALREADY_EXISTS: 'Podany adres email już posiada konto w naszym systemie',
        activateUserComplete: {
            VALID_TOKEN_NOT_FOUND: 'Podany token z adresu URL wygasł. Prosimy ponownie wygenerować token aby ukończyć aktywację.'
        },
        somethingWentWrong: 'Coś poszło nie tak... Spróbuj ponownie wykonać akcję',
        VIN_ALREADY_IN_DATABASE: 'Vin już istnieje',
        LICENSE_PLATE_IS_ALREADY_IN_DATABASE: 'Numer rejestracyjny już istnieje',
        OUTDATED_TECHNICIAN_INSURANCE: 'Monter nie posiada aktualnej polisy',
        number: 'Wartość musi być liczbą lub cyfrą',
        greaterThanZero: 'Wartość musi być większa od zera',
        specialCharacter: 'Hasło musi zawierać znak specjalny',
        minPasswordLength: 'Hasło musi zawierać min 8 znaków',
        oneGreatLetter: 'Hasło musi zawierać co najmniej jedną dużą litere',
        oneSmallLetter: 'Hasło musi zawierać co najmniej jedną małą litere',
        oneNumber: 'Hasło musi zawierać co najmniej jedną cyfre',
        futureDate: 'Data z przeszłości',
        required: 'Pole wymagane',
        incorrectEmail: 'Niepoprawny adres email',
        incorrectPostalCode: 'Niepoprawny kod pocztowy',
        incorrectPhoneNo: 'Niepoprawny numer telefonu',
        incorrectLicensePlate: 'Niepoprawny numer rejestracyjny',
        incorrectDate: 'Niepoprawna data',
        CAR_FLEET_NOT_REMOVABLE: 'Flota: {{fleetId}} nie jest usuwalna'
    }
};

export default errors;



// WEBPACK FOOTER //
// ./src/Translations/Errors.ts